export default __webpack_public_path__ + "static/media/HTML5_Badge.3f514250.svg";